import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { toCSS } from '../../helpers/styles';
import {
  uiSetPrimaryHook,
  uiSetSecondaryHook,
} from '../../store/actions/executor.actions';
import { ANIMATED_ELEMENT_TYPES, AnimatedElement } from './AnimatedPoint';

interface IHookablePoint {
  x: number;
  y: number;
  id: string;
  stroke?: string;
  fill?: string;
  radius?: number;
  latitude?: string;
  longitude?: string;
  hookProperties?: any;
  imageUrl?: string;
  transitionTime?: number;
  hookSize?: number;
  trackSymbolHeight?: number;
  trackSymbolWidth?: number;
  pauseAnimation?: boolean;
}

const StyledImage = styled.image<any>`
  cursor: pointer;
`;
// ${({ x, y, width, height, duration }) => `
//       x: ${toCSS(+x - +width / 2)};
//       y: ${toCSS(+y - +height / 2)};
//       `};
// transition: x ${duration}ms ease, y ${duration}ms ease;

const StyledCircle = styled.circle<any>`
  ${({ transitionTime }) => `
    transition: cx ${transitionTime}ms ease, cy ${transitionTime}ms ease;
`};
`;

const StyledRect = styled.rect<any>`
  ${({ x, y, transitionTime }) => `
      x: ${toCSS(+x)};
      y: ${toCSS(+y)};
      transition: x ${transitionTime}ms ease, y ${transitionTime}ms ease;
`};
`;

export default function HookablePoint(props: IHookablePoint) {
  const {
    x,
    y,
    id,
    stroke,
    fill,
    radius,
    latitude = '',
    longitude = '',
    hookProperties,
    imageUrl,
    transitionTime,
    hookSize,
    trackSymbolHeight,
    trackSymbolWidth,
    pauseAnimation,
  } = props;

  const [isHooked, setIsHooked] = useState({
    isPrimaryHooked: false,
    isSecondaryHooked: false,
  });

  const { primaryHookId, secondaryHookId } = useSelector(
    (state: any) => state.executor.hookedItems
  );

  useEffect(() => {
    setIsHooked({
      isPrimaryHooked: primaryHookId !== '' && primaryHookId === id,
      isSecondaryHooked: secondaryHookId !== '' && secondaryHookId === id,
    });
  }, [primaryHookId, secondaryHookId, id]);

  const dispatch = useDispatch();

  const onWayPointClick = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    dispatch(
      uiSetPrimaryHook({
        latitude,
        longitude,
        hookProperties,
        identifier: id,
      })
    );
  };

  const onSecondaryWayPointClick = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    dispatch(
      uiSetSecondaryHook({
        latitude,
        longitude,
        hookProperties,
        identifier: id,
      })
    );
  };
  const r = radius || '4';
  return (
    <>
      <DisplayPoint
        x={x}
        transitionTime={transitionTime}
        y={y}
        id={id}
        r={r}
        stroke={stroke || 'black'}
        fill={fill || 'yellow'}
        imageUrl={imageUrl}
        onWayPointClick={onWayPointClick}
        onSecondaryWayPointClick={onSecondaryWayPointClick}
        trackSymbolHeight={trackSymbolHeight}
        trackSymbolWidth={trackSymbolWidth}
        pauseAnimation={pauseAnimation}
      />
      {isHooked.isPrimaryHooked && (
        <AnimatedElement
          pauseAnimation={pauseAnimation}
          elementType={ANIMATED_ELEMENT_TYPES.CIRCLE}
          duration={transitionTime}
          transitionObject={{
            cx: x,
            cy: y,
          }}
          r={hookSize || +r + 3}
          stroke="white"
          strokeWidth="1"
          fill="none"
        />
      )}
      {/* <StyledCircle
        cx={x}
        cy={y}
        r={hookSize || +r + 3}
        transitionTime={transitionTime}
        stroke="white"
        strokeWidth="1"
        fill="none"
      /> */}
      {isHooked.isSecondaryHooked && (
        <AnimatedElement
          pauseAnimation={pauseAnimation}
          duration={transitionTime}
          elementType={ANIMATED_ELEMENT_TYPES.RECTANGLE}
          transitionObject={{
            x: toCSS(hookSize ? x - hookSize : x - 6),
            y: toCSS(hookSize ? y - hookSize : y - 6),
          }}
          height={hookSize ? hookSize * 2 : 12}
          width={hookSize ? hookSize * 2 : 12}
          stroke="white"
          fill="none"
        />
      )}
      {/* <StyledRect
         x={hookSize ? x - hookSize : x - 6}
         y={hookSize ? y - hookSize : y - 6}
         height={hookSize ? hookSize * 2 : 12}
         width={hookSize ? hookSize * 2 : 12}
         stroke="white"
         transitionTime={transitionTime}
         fill="none"
       /> */}
    </>
  );
}

const DisplayPoint = ({
  x,
  y,
  imageUrl,
  transitionTime,
  id,
  r,
  stroke,
  fill,
  trackSymbolHeight = 30,
  trackSymbolWidth = 30,
  onWayPointClick,
  onSecondaryWayPointClick,
  pauseAnimation,
}: {
  x: number;
  y: number;
  id: string;
  stroke: string;
  fill: string;
  r: any;
  imageUrl?: string;
  transitionTime?: number;
  trackSymbolHeight?: number;
  trackSymbolWidth?: number;
  onWayPointClick: (hookProperties: any) => void;
  onSecondaryWayPointClick: (hookProperties: any) => void;
  pauseAnimation?: boolean;
}) => {
  if (imageUrl) {
    return (
      <AnimatedElement
        pauseAnimation={pauseAnimation}
        duration={transitionTime}
        elementType={ANIMATED_ELEMENT_TYPES.IMAGE}
        transitionObject={{
          x: toCSS(+x - +trackSymbolWidth / 2),
          y: toCSS(+y - +trackSymbolHeight / 2),
        }}
        id={`_${id}`}
        data-area="track image"
        href={imageUrl}
        onClick={onWayPointClick}
        onContextMenu={onSecondaryWayPointClick}
        width={trackSymbolWidth}
        height={trackSymbolHeight}
      />

      // <AnimatePath
      //   pauseAnimation={pauseAnimation}
      //   duration={transitionTime ?? 500}
      //   transitionPoints={{
      //     x: toCSS(+x - +trackSymbolWidth / 2),
      //     y: toCSS(+y - +trackSymbolHeight / 2),
      //   }}
      //   id={`_${id}`}
      // >
      //   <StyledImage
      //     x={x}
      //     duration={transitionTime}
      //     y={y}
      //     id={`_${id}`}
      //     width={trackSymbolWidth}
      //     height={trackSymbolHeight}
      //     data-area="track image"
      //     href={imageUrl}
      //     onClick={onWayPointClick}
      //     onContextMenu={onSecondaryWayPointClick}
      //   />
      // </AnimatePath>
    );
  }
  return (
    <AnimatedElement
      pauseAnimation={pauseAnimation}
      elementType={ANIMATED_ELEMENT_TYPES.CIRCLE}
      duration={transitionTime}
      transitionObject={{
        cx: x,
        cy: y,
      }}
      r={r}
      fill={fill || 'yellow'}
      stroke={stroke || 'black'}
      strokeWidth="1"
      fill-opacity="1"
      id={`_${id}`}
      onClick={onWayPointClick}
      onContextMenu={onSecondaryWayPointClick}
    />

    // <StyledCircle
    //   cx={x}
    //   cy={y}
    //   r={r}
    //   stroke={stroke || 'black'}
    //   strokeWidth="1"
    //   fill={fill || 'yellow'}
    //   fill-opacity="1"
    //   id={`_${id}`}
    //   transitionTime={transitionTime}
    //   onClick={onWayPointClick}
    //   onContextMenu={onSecondaryWayPointClick}
    // />
  );
};
